export default __webpack_public_path__ + "img/special-offer.baf07333c8ef03b545a9b3c5baba3fbd.png";